import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=04b28064&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
import style0 from "./InputText.vue?vue&type=style&index=0&id=04b28064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b28064",
  null
  
)

export default component.exports